import CoachMarks from "@maersk-global/coach-marks";

export const showCoachMarks = (items, closeLabel, trackingFeatureName) => {
  if (!items?.length) return;
  // check if empty object then return
  const options = {
    finishLabel: closeLabel,
    outsideClickHandler: () => {
      document.getElementsByClassName("coach-marks-overlay")[0].remove();
    },
    finishHandler: () => {
      document.getElementsByClassName("coach-marks-overlay")[0].remove();
    },
    seenHandler: () => {
      const overlay = document.createElement("div");
      overlay.className = "coach-marks-overlay";
      overlay.dataset.test = "coach-marks-overlay";
      document.body.appendChild(overlay);
    },
    highlightClass: "coach-marks-highlight",
    items: items,
    theme: "light"
  };

  const coach = new CoachMarks(options);
  coach.start();

  // Send non-translated title
  globalThis.dataLayer.push({
    event: "DQCS",
    category: "SO_Coachmarks",
    action: "Click",
    label: {
      data: "showCoachMarksSO",
      feature: trackingFeatureName
    }
  });
};
